export const environment = {
  "API_KEY": "your_development_api_key",
  "BASE_URL": "https://dev-mct.pearsonvue.com",
  "APP_URL": "https://dev-mct.pearsonvue.com",
  "COURSE_URL": "https://www.mindhubpro.com/shop/courseware",
  "CLASS_URL": "https://certprepcourseware-staging.pearson.com/certprep-manager",
  "LIVE_URL": "https://virtualclassmarketplace.pearsonvue.com/?variant=corporate",
  "VOUCH_URL": "https://www.mindhubpro.com/shop/skilling-voucher-store",
  "IES_URL": "https://iam-social-stage.pearson.com",
  "RECAPTCHA_SITE_KEY": "6LdSHiUtAAAAAB5tqLFBw0BZBEyOsqs-kHfmkj_x"
};